import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    UpgradeHelper, JourneyImportAndExportHelper, JourneyRollbackHelper, AdminToolHelper
} from '../../../helpers';

import { Checkbox, Button, Pivot, PivotItem, PivotLinkSize, IDropdownOption, ButtonType } from 'office-ui-fabric-react';
import store from '../../../store/store';
import { getJourneysByTerm } from '../../../helpers/io';
import { Promise } from 'es6-promise';
import { Search } from '../../common/search';
import { connect } from 'react-redux';
import types from '../../../store/types';
import { AdminToolList, RollbackSelector, ZipImport } from '../../admintool/panels';
import { ProcessUpgradePage } from '../../admintool/screens/processupgradepage';
import { JESettingsList } from '../panels/jesettingslist';
import JESettingsSidebarContainer from '../../../containers/jesettings-sidebar';
import { JourneyEngineSettingsHelper } from '../../../helpers/journeyenginesettingshelper';

interface IProps {
    adminToolState: any;
    searchState: any;
    toggleSidebar: () => void;
}
declare var jQuery;
export class JESettingsScreen extends React.Component<IProps, any> {
    componentDidMount() {
    }
    onSelectUpgradeToolMode(mode: string) {
        AdminToolHelper.SetPageMode(mode);
    }

    getButtonCss(mode): string {
        return this.props.adminToolState.pageMode == mode ? "active" : "";
    }

    updateServerOnly(jesettingsId: string, value: number) {
        let jesettingsToUpdate;
        let jesettingsPanel = store.getState().adminToolState.panels.filter(x => x.panelName === 'jesettings_select')[0]

        if (jesettingsPanel) {
            jesettingsToUpdate = jesettingsPanel.values.jesettingsList && jesettingsPanel.values.jesettingsList.filter(x => x.journeyEngineSettingsId === jesettingsId)
        }
        if (jesettingsToUpdate) {
            jesettingsToUpdate[0].serverOnly = value;
            JourneyEngineSettingsHelper.updateFromJESettingsList("jesettings_select", jesettingsToUpdate[0]).then(() => {
            })
        }
    }
    render() {
        // if (this.props.adminToolState.isUpgradingScreen) {
        //     return (<div>
        //         <ProcessUpgradePage showStatus={true} adminToolState={this.props.adminToolState} />
        //     </div>);
        // }
        // else {
        let textBoxValue: string = "";
        return (<div>
            <h2>Journey Engine Settings</h2>
            <JESettingsList toggleSidebar={this.props.toggleSidebar} updateServerOnly={this.updateServerOnly} adminToolState={this.props.adminToolState} panelName={"jesettings_select"} enableRemoveButtons={true} showStatus={false} />
            <JESettingsSidebarContainer panelName={"jesettings_select"} />
            {/* <div className="upgradesettings">
                    <div className="upgradesettinglist">
                        <label>Show Verbose Output:</label>
                        <Checkbox name="advancedLogging" default={false}
                            onChange={(e, isChecked: boolean) => {
                                AdminToolHelper.SetAdminToolSetting(isChecked);
                            }}
                        />
                    </div>
                    <Button
                        icon="Accept"
                        buttonType={ButtonType.primary}
                        onClick={() => JourneyRollbackHelper.StartUpRollbackProcess(this.props.adminToolState.processList)}>
                        Rollback
                        </Button>
                </div> */}
        </div>
        );
        // }
    }
}




// WEBPACK FOOTER //
// ./source/ts/components/admintool/screens/jesettingsscreen.tsx